import './style.css';
import React from 'react';
import PropTypes from 'prop-types';

export default function LoadingDots({ color }) {
  return (
    <div className="loading-dot-container">
      <div
        className="loading-dot loading-dot-1"
        style={{
          backgroundColor: color,
        }}
      />
      <div
        className="loading-dot loading-dot-2"
        style={{
          backgroundColor: color,
        }}
      />
      <div
        className="loading-dot loading-dot-3"
        style={{
          backgroundColor: color,
        }}
      />
    </div>
  );
}

LoadingDots.propTypes = {
  color: PropTypes.string,
};
